
const initMegaMenu = (options) => {
  const megaMenuLinks = [...document.querySelectorAll('.nav--main-nav .nav__link--parent')]
  const megaMenuBackdrop = document.getElementById('header-nav-backdrop')

  const handleTouchEvent = (navItem,e) => {

    if (window.innerWidth < (options?.largeWidth ?? 1200)) {
      return true
    }

    if (navItem.classList.contains('open')) {
      return true
    }

    //close all siblings, open current
    closeSiblings(navItem)
    //prevent click first time
    e.preventDefault()
  }

  const closeSiblings = (excludedElement) => {
    megaMenuBackdrop.classList.toggle('header__nav-backdrop--show', excludedElement)
    megaMenuLinks.map( siblings => siblings.classList.toggle('open', siblings === excludedElement ) )
  }

  megaMenuBackdrop.addEventListener('click', () => closeSiblings() )

  megaMenuLinks.forEach( menuLink => {
    menuLink.addEventListener('touchend', (event) => {
      handleTouchEvent(menuLink,event)
    })
    menuLink.addEventListener('keydown', (event) => {
      if (event.code === 'Space') {
        event.preventDefault()

        closeSiblings( menuLink.classList.contains('open') ? null : menuLink )
        return false
      }else if(event.code === 'Escape'){
        closeSiblings()
      }
    })
  })


}

export default initMegaMenu